export default __webpack_public_path__ + "assets/brazil-flag.png";